import styled from 'styled-components';
import { Styling } from '../../../../constants';

export const InfoLabel = styled.span`
  margin-right: ${Styling.DEFAULT_SPACING}px;
`;

export const InfoValue = styled.span`
  font-weight: 700;
`;

export const PaginationTotal = styled.span`
  display: inline-flex;
  align-items: center;
`;

export const PaginationSize = styled.span`
  display: inline-flex;
  align-items: center;
`;

export const SearchResponseInfoContainer = styled.div`
  display: flex;
  align-items: center;
`;
